"use client"

import type React from "react"

import { useEffect, useState } from "react"

interface WelcomeGreetingProps {
  name: string
}

const WelcomeGreeting: React.FC<WelcomeGreetingProps> = ({ name }) => {
  const [greeting, setGreeting] = useState("")

  useEffect(() => {
    const hour = new Date().getHours()
    if (hour < 12) {
      setGreeting("Good morning")
    } else if (hour < 18) {
      setGreeting("Good afternoon")
    } else {
      setGreeting("Good evening")
    }
  }, [])

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-800 dark:text-white">
        {greeting}, {name}!
      </h1>
      <p className="text-gray-600 dark:text-gray-300 mt-1">Welcome to your employee dashboard</p>
    </div>
  )
}

export default WelcomeGreeting
